import { Spacer } from 'app-v2/design-systems/components/Spacer/Spacer'
import { SIZE } from 'app-v2/design-tokens'
import React from 'react'
import { useIntl } from 'react-intl'
//$FlowFixMe
import shoes from '../../../assets/shoes.webp'
//$FlowFixMe
import umbrella from '../../../assets/umbrella.webp'
import { FAQItem } from './FAQItem'
import styled, { css } from 'styled-components'
import { colors } from 'app-v2/design-systems/theme/colors'
import { fonts } from 'app-v2/design-systems/typography/fonts'
import { media } from '../../../../assets/styles'
import { SPACING } from '../../../../../app-v2/design-tokens'

export const FAQ = () => {
    const intl = useIntl()
    return (
        <StyledFaqFullPageContainer>
            <Spacer size={SIZE.XXL} />
            <StyledFaqContainer>
                <StyledFaqTitleContainer>
                    <StyledFaqTitle>
                        {intl.formatMessage({
                            id: 'tupreferesking.home.faq.title'
                        })}
                    </StyledFaqTitle>
                    <StyledShoesIconContainer>
                        <img src={shoes} alt={'shoes'} />
                    </StyledShoesIconContainer>
                </StyledFaqTitleContainer>
                <StyledFaqQuestionsContainer>
                    <FAQItem
                        question={intl.formatMessage({
                            id: 'tupreferesking.home.faq.1.q'
                        })}>
                        {intl.formatMessage({
                            id: 'tupreferesking.home.faq.1.a'
                        })}
                    </FAQItem>
                    <FAQItem
                        question={intl.formatMessage({
                            id: 'tupreferesking.home.faq.2.q'
                        })}>
                        <p>
                            {intl.formatMessage({
                                id: 'tupreferesking.home.faq.2.a1'
                            })}
                        </p>
                        <ul>
                            {intl
                                .formatMessage({
                                    id: 'tupreferesking.home.faq.2.a2'
                                })
                                .split('\n')
                                .map((element, i) => (
                                    <li key={i}>{element}</li>
                                ))}
                        </ul>
                        <p>
                            {intl.formatMessage({
                                id: 'tupreferesking.home.faq.2.a3'
                            })}
                        </p>
                        <p>
                            {intl.formatMessage({
                                id: 'tupreferesking.home.2.a3.car'
                            })}
                        </p>
                        <p>
                            {intl.formatMessage({
                                id: 'tupreferesking.home.faq.2.a5'
                            })}
                        </p>
                        <p>
                            {intl.formatMessage({
                                id: 'tupreferesking.home.faq.2.a6'
                            })}
                            <a
                                target={'_blank'}
                                href={
                                    'https://www.ticknbox.com/fr_FR/100-foot-matchs-stadiumtour.html'
                                }>
                                {intl.formatMessage({
                                    id: 'tupreferesking.home.faq.2.a7'
                                })}
                            </a>
                            {intl.formatMessage({
                                id: 'tupreferesking.home.faq.2.a8'
                            })}
                        </p>
                        <p>
                            {intl.formatMessage({
                                id: 'tupreferesking.home.faq.2.a9'
                            })}
                        </p>
                        <p>
                            {intl
                                .formatMessage({
                                    id: 'tupreferesking.home.faq.2.a10'
                                })
                                .split('\n')
                                .map((element, i) => (
                                    <div key={i}>{element}</div>
                                ))}
                        </p>
                        <p>
                            {intl.formatMessage({
                                id: 'tupreferesking.home.faq.2.a11'
                            })}
                        </p>
                        <p>
                            {intl.formatMessage({
                                id: 'tupreferesking.home.faq.2.a12'
                            })}
                        </p>
                        <h4>
                            {intl.formatMessage({
                                id: 'tupreferesking.home.reminder-keep'
                            })}
                        </h4>
                    </FAQItem>
                    <FAQItem
                        question={intl.formatMessage({
                            id: 'tupreferesking.home.faq.3.q'
                        })}>
                        <ul>
                            <li>
                                <b>
                                    {intl.formatMessage({
                                        id: 'tupreferesking.home.faq.3.a1'
                                    })}
                                </b>{' '}
                                {intl.formatMessage({
                                    id: 'tupreferesking.home.faq.3.a1.text'
                                })}
                            </li>
                            <li>
                                <b>
                                    {intl.formatMessage({
                                        id: 'tupreferesking.home.faq.3.a2'
                                    })}
                                </b>{' '}
                                {intl.formatMessage({
                                    id: 'tupreferesking.home.faq.3.a2.text'
                                })}
                            </li>
                            <li>
                                <b>
                                    {intl.formatMessage({
                                        id: 'tupreferesking.home.faq.3.a3'
                                    })}
                                </b>{' '}
                                {intl.formatMessage({
                                    id: 'tupreferesking.home.faq.3.a3.text'
                                })}
                            </li>
                            <li>
                                <b>
                                    {intl.formatMessage({
                                        id: 'tupreferesking.home.faq.3.a4'
                                    })}
                                </b>{' '}
                                {intl.formatMessage({
                                    id: 'tupreferesking.home.faq.3.a4.text'
                                })}
                            </li>
                            <li>
                                <b>
                                    {intl.formatMessage({
                                        id: 'tupreferesking.home.faq.3.a5'
                                    })}
                                </b>{' '}
                                {intl.formatMessage({
                                    id: 'tupreferesking.home.faq.3.a5.text'
                                })}
                            </li>
                        </ul>
                        <h4>
                            {intl.formatMessage({
                                id: 'tupreferesking.home.reminder-keep'
                            })}
                        </h4>
                    </FAQItem>
                    <FAQItem
                        question={intl.formatMessage({
                            id: 'tupreferesking.home.faq.4.q'
                        })}>
                        <p>
                            <ul>
                                <li>
                                    <b>
                                        {intl.formatMessage({
                                            id: 'tupreferesking.home.faq.4.a1'
                                        })}
                                    </b>
                                </li>
                            </ul>
                            {intl
                                .formatMessage({
                                    id: 'tupreferesking.home.faq.4.a2'
                                })
                                .split('\n')
                                .map((element, i) => (
                                    <div key={i}>{element}</div>
                                ))}
                        </p>
                        <p>
                            <ul>
                                <li>
                                    <b>
                                        {intl.formatMessage({
                                            id: 'tupreferesking.home.faq.4.a3'
                                        })}
                                    </b>
                                </li>
                            </ul>
                            {intl
                                .formatMessage({
                                    id: 'tupreferesking.home.faq.4.a4'
                                })
                                .split('\n')
                                .map((element, i) => (
                                    <div key={i}>{element}</div>
                                ))}
                        </p>
                    </FAQItem>
                </StyledFaqQuestionsContainer>
            </StyledFaqContainer>
            <Spacer size={SIZE.XXL} />
            <StyledUmbrellaIconContainer>
                <img src={umbrella} alt={'umbrella'} />
            </StyledUmbrellaIconContainer>
        </StyledFaqFullPageContainer>
    )
}

const faqContainerLarger = css`
    flex-direction: row;
    justify-content: flex-start;
`

const StyledFaqFullPageContainer = styled.div`
    background: ${colors.darkMayo};
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 24px;
    box-sizing: border-box;
    position: relative;
`

const StyledFaqContainer = styled.div`
    max-width: 1340px;
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-content: center;
    ${media.small`${faqContainerLarger}`}
    gap: 40px;
`

const StyledFaqTitle = styled.h2`
    text-transform: uppercase;
    font-size: 24px;
    ${media.small`font-size: 28px;`}
    line-height: 1.1;
    color: ${colors.bbqBrown};
    text-align: center;
    ${media.small`text-align: left;`}
    max-width: 350px;
    font-family: ${fonts.flameBold};
`

const StyledShoesIconContainer = styled.div`
    display: flex;
    position: absolute;
    top: -${SPACING.XXL};
    left: -60px;
    ${media.small`
        top: 46px;
        left: 0;`}
    height: ${SPACING.XL};
`

const StyledUmbrellaIconContainer = styled.div`
    display: flex;
    position: absolute;
    bottom: 0;
    right: 0;
    img {
        position: absolute;
        right: ${SPACING.L};
        bottom: 0;
        height: ${SPACING.XL};
    }
`

const StyledFaqTitleContainer = styled.div`
    ${media.small`align-self: flex-start;`}
    align-self: center;
    flex: 1;
    position: relative;
`

const StyledFaqQuestionsContainer = styled.div`
    flex: 1.5;
`
